import { cva, type VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-5 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-[#1b1b1c] text-white hover:bg-[#1b1b1c]/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        accent: "bg-sds-purple-100 text-white hover:bg-sds-purple-80",
        outline:
          "border border-[#e8e8e8] bg-white text-sds-text-black hover:bg-[#f9f9f9]",
        secondary: "bg-sds-neutral-80 text-white hover:bg-sds-neutral-100",
        ghost: "bg-transparent text-sds-text-black hover:bg-sds-neutral-00",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 text-base",
        sm: "h-9 px-3 text-sm",
        lg: "h-10 px-6 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;
